import { Stack, Text } from '@fluentui/react';
import { Handle, Position } from '@xyflow/react';

// function TextUpdaterNode({ data, isConnectable }) {

// @ts-ignore
export const TitleNode: React.FC = ({ data, isConnectable, ...rest }) => {
  return (
    <Stack style={{ width: 300 }} horizontalAlign="center">
      <Text variant="xLargePlus">{data.label}</Text>
      <Handle
        id="a"
        type="source"
        position={Position.Bottom}
        // hidden
        style={{ visibility: 'hidden' }}
        isConnectable={isConnectable}
      />
    </Stack>
  );
};
